module.exports = __webpack_public_path__ + "static/media/Job2.232efb85.png";